<template>
    <div class="shop-content">
        <ph-header>
            <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
        </ph-header>
        <div class="notice-content">
            关于胖虎
        </div>
    </div>
</template>

<script>
import PhHeader from '@/components/common/Header'
export default {
  name: 'shopNotice',
  components: {
    PhHeader
  }
}
</script>

<style lang="less" scoped>

</style>
